module.exports = __webpack_public_path__ + "static/media/lat.289eb3f7.mp3";